import { Money } from '@/domain/controlling/entities';
import { HTMLAttributes } from 'react';
import { formatNumber } from '../../utils';

export function MoneyField({
  className,
  value,
  unit,
}: {
  value: Money | undefined;
  unit?: string;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`flex gap-1 items-baseline text-sm font-semibold whitespace-nowrap text-neutrals-N900 ${className}`}>
      <div>
        {value !== undefined && value !== null
          ? formatNumber(value.amount.toString(), false)
          : '--'}{' '}
      </div>
      <div className="text-neutrals-N700">{unit}</div>
    </div>
  );
}
